<template lang="pug">

.empty-panel
  .flex-wrap
    .info-box


      .main-info
        p Use iTrain to publlish key training and e-learning content to your colleagues
        p You can set training to be issued at specific dates and times. Upload content including PowerPoint, PDF and SCORM Files. Monitor progress and results at a glance with comprehensive reporting features.


      .check-list
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p SCORM Compliant Hosting (standardised e-learning modules)
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p Support for Powerpoint, PDF and other docs
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p Notify users via SMS or email with ability to customise messages
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p Detailed reports to view analytics to monitor performance of teams
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p Set expiry deadlines and recurring training modules
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p Customise look and feel of training portal
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p Structure training audiences by creating learner groups
        .check
          fa-layers.fa-2x
            fa-icon(:icon="['far','circle']" )
            fa-icon(icon="check" transform="shrink-8")
          .text-box
            p Assign bespoke training content to learner groups


      router-link(:to="{ name: 'itrain:courseCreate' }")
                .el-button.pink GET STARTED
    .img-box
        img(src='@/assets/images/emptystates/itrain-holder.png')
</template>

<script>
export default {};
</script>
